import { MessageSquare, FileText, Wrench, TrendingUp } from "lucide-react";

const HowItWorks = () => {
  const steps = [
    {
      number: "01",
      icon: MessageSquare,
      title: "Free Consultation",
      description:
        "We review your listing or discuss your property and identify the biggest opportunities.",
    },
    {
      number: "02",
      icon: FileText,
      title: "Custom Strategy",
      description:
        "You receive a tailored plan: pricing targets, listing improvements, and a 30-day action roadmap.",
    },
    {
      number: "03",
      icon: Wrench,
      title: "We Get to Work",
      description:
        "We implement everything — or hand you a detailed audit to action yourself.",
    },
    {
      number: "04",
      icon: TrendingUp,
      title: "Watch the Results",
      description:
        "Better rankings, more bookings, higher revenue. We track everything.",
    },
  ];

  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="section-padding bg-cream"
    >
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-[0.2em] text-gold font-semibold mb-4">
            How It Works
          </p>
          <h2 className="section-heading">Simple, transparent, effective</h2>
        </div>

        {/* Timeline */}
        <div className="grid md:grid-cols-4 gap-8 lg:gap-12">
          {steps.map((step, index) => {
            const Icon = step.icon;

            return (
              <div
                key={step.number}
                className="timeline-step text-center md:text-left"
                data-testid={`step-${step.number}`}
              >
                {/* Step Number */}
                <div className="timeline-number mb-4">{step.number}</div>

                {/* Icon */}
                <div className="w-12 h-12 bg-gold-light text-gold flex items-center justify-center mb-4 mx-auto md:mx-0">
                  <Icon size={24} />
                </div>

                {/* Content */}
                <h3 className="text-xl font-serif text-bark mb-3">
                  {step.title}
                </h3>
                <p className="text-bark-light text-sm leading-relaxed">
                  {step.description}
                </p>

                {/* Connector Line (hidden on mobile and last item) */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-8 left-full w-full h-px bg-gold/20 -z-10" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
